import { isEmpty } from 'shared/utils/Validation';

const isRegisteredInAustraliaOutsideNSW = (addressObject) => {
  if (
    addressObject?.addressType === 'local' &&
    !isEmpty(addressObject?.addressUi?.state?.value) &&
    addressObject?.addressUi?.state?.value !== 'NSW'
  ) {
    return true;
  } else if (addressObject?.addressType === 'international') {
    if (!isEmpty(addressObject?.address?.country) && !isEmpty(addressObject?.address?.province)) {
      if (addressObject?.address?.country.toLowerCase() === 'australia') {
        if (
          addressObject?.address?.province.toLowerCase().trim() !== 'nsw' &&
          addressObject?.address?.province.toLowerCase().trim() !== 'new south wales'
        )
          return true;
      }
    }
  }

  return false;
};

export { isRegisteredInAustraliaOutsideNSW };
